<template>
    <div class="cms-container ">
        <!-- <div class="flex align-center justify-between list-item" v-for="(item, index) in dataList" :key="index"
            @click="toDetails(item)">
            <li class="flex-1 font-18">
                <div class="text-omit-1">{{ item.name }}</div>
            </li>
            <div class="font-14" style="margin-left: 50px;">{{ item.createTime | fmDate }}</div>
        </div> -->
        <ul class="size-18 ul-disc" >
            <li class="right-li li-before  li-line-height  font-18 flex align-center justify-between"
                v-for="(item, index) in dataList" :key="index" @click="toDetails(item)">
                <div class="flex-1 text-omit-1 text-width">{{ item.name }}
                </div>
                <div class="font-14">{{ item.createTime | fmDate }}</div>
            </li>
        </ul>
        <div class="more-btn text-center font-18" @click="handleMore">查看更多</div>
        <!-- <div v-if="activeMenu.name !== '首页网站' && dataTotal > 20" class="flex" style="justify-content: end;">
            <el-pagination layout="prev, pager, next" :total="dataTotal" @current-change="handleCurrentChange"
                :current-page.sync="pageNum" :page-size="20">
            </el-pagination>
        </div> -->
    </div>
</template>

<script>

export default {
    props: {
        activeMenu: {
            type: Object,
            default: () => ({})
        },
        dataList: {
            type: Array,
            default: () => []
        },
        dataTotal: {
            type: Number,
            default: 0
        },
        pageNo: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            pageNum: 1
        }
    },
    watch: {
        pageNo(newVal, oldVal) {
            this.pageNum = newVal
        }
    },
    methods: {
        handleMore() {
            // this.$emit('handleMore')

            const routeUrl = this.$router.resolve({
                path: '/details/list',
                query: this.activeMenu
            });
            window.open(routeUrl.href);
        },
        toDetails(item) {
            const routeUrl = this.$router.resolve({
                path: '/details',
                query: { id: item.id }
            });
            window.open(routeUrl.href);
        },
        handleCurrentChange(val) {
            this.$emit('update', val)
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-container {
    width: 100%;
    box-sizing: border-box;
    min-height: 300px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px #C5C5C5;
    border-radius: 20px;
    border: 1px solid #BFBFBF;
    padding: 50px 80px 40px 100px;
    margin-bottom: 100px;

    .list-item {
        color: #000000;
        cursor: pointer;
        line-height: 48px;
    }

    .ul-disc {
        padding-left: 0;
        list-style: none;
        color: #000000;
        cursor: pointer;
        line-height: 48px;
        margin-bottom: 60px;
    }

    /* li 圆点 */
    .ul-disc li {
        position: relative;
        padding-left: 15px;
    }

    .right-li {
        padding-bottom: 0 !important;
    }

    .li-before:before {
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #A40000;
        display: block;
        margin-right: 5px;
        /* vertical-align: middle; */
        // margin-top: -3px;
        position: absolute;
        left: 0;
        top: 50%;
    }

    .li-before:hover::before {
        background: #A40000;
    }

    .li-before:hover {
        color: #A40000;
    }

    li::marker {
        color: #A40000 !important;
    }

    .text-width {
        margin-right: 50px;
    }

    .more-btn {
        width: 170px;
        height: 50px;
        line-height: 50px;
        background: #A40000;
        border-radius: 25px;
        color: #FFFFFF;
        margin: 30px auto 0;
        cursor: pointer;
    }
}

::v-deep .el-pager li.active {
    color: #A40000 !important;
}

::v-deep .el-pager li:hover {
    color: #A40000 !important;
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
    .cms-container {
        padding: 40px 30px 30px 50px;
        margin-bottom: 60px;

        .ul-disc {
            font-size: 16px;
            line-height: 40px;
            margin-bottom: 30px;

            li {
                padding-left: 12px;

                .font-18 {
                    font-size: 16px !important;
                }

                .font-14 {
                    font-size: 12px !important;
                    margin-left: 30px !important;
                }
            }
        }

        .text-width {
            margin-right: 2%;
        }

        .more-btn {
            width: 140px;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            margin: 20px auto 0;
        }
    }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
    .cms-container {
        padding: 24px 16px 20px 20px;
        margin-bottom: 40px;
        border-radius: 12px;

        .ul-disc {
            font-size: 14px;
            line-height: 36px;
            margin-bottom: 0 !important;

            li {
                padding-left: 10px;
                align-items: flex-start !important;

                .text-width {
                    margin-right: 20px;
                }

                .font-18 {
                    font-size: 14px !important;
                }

                .font-14 {
                    font-size: 12px !important;
                    margin-left: 0 !important;
                    color: #999;
                }
            }
        }

        .more-btn {
            width: 120px;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            margin: 16px auto 0;
        }
    }
}
</style>